import React/*, { Component }*/ from "react";
import Header from "../components/Header";
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import PartLookupSearchBox from "../components/PartLookupSearchBox";
import PartDemandPage from './PartDemandPage';
import { DateCell, BlankCell, IconButtonCell } from "../components/utils/GridHelpers";
import { queryStringBuilder, getExportFileName, isEmpty, escapeSlashes } from "../helpers";
import GridContainer from '../components/GridContainer';
import {
    GridColumn as Column,
    GridDetailRow,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import "@progress/kendo-theme-material/dist/all.css";
import isPage from "../hoc/isPage";
import { AppContext } from '../context/AppContext';
import localize from "../hoc/localize";

const uuidv4 = require('uuid/v4');

class DetailComponent extends GridDetailRow {
    render() {

        // get data for the subtable
        const data = this.props.dataItem.details;

        const status = this.props.dataItem.status;
        const hasSupersededHistory = this.props.dataItem.supersededHistory;

        if (data) {
            if (
                (!isEmpty(status) && status.toLowerCase() === "superseded") ||
                hasSupersededHistory
            ) {
                return (
                    <div className="detail-grid">
                        <GridContainer data={data}>
                            <Column field="effectiveDate" title={this.props.returnLocalizedString("m0282")} width="175px"
                                cell={props => (
                                    <DateCell {...props} />
                                )} />
                            <Column field="oldPartNumber" title={this.props.returnLocalizedString("m0283")} width="175px" />
                            <Column field="newPartNumber" title={this.props.returnLocalizedString("m0284")} width="175px" />
                            <Column cell={(props) => (<BlankCell {...props} />)} />

                        </GridContainer>
                    </div>
                );
            } else {
                return (<div>{this.props.returnLocalizedString("m0285")}</div>);
            }
        } else {
            return (
                <div style={{ height: 50, width: "100%" }}>
                    <div style={{ position: "absolute", width: "100%" }}>
                        <div className="k-loading-image" />
                    </div>
                </div>
            );
        }
    }
}

function columns (props) {
    return [
    { field: "location", key: "location", title: props.returnLocalizedString("m0296"), minWidnt: 20 },
    { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20 },
    { field: "description", key: "description", title: props.returnLocalizedString("m0258"), minWidnt: 20 },
    { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20 },
    { field: "quantityAvailable", key: "quantityAvailable", title: props.returnLocalizedString("m0287"), minWidnt: 20, headerClassName: "numeric", className: "numeric" },
    { field: "qtySalesInProgress", key: "qtySalesInProgress", title: props.returnLocalizedString("m0288"), minWidnt: 20, headerClassName: "numeric", className: "numeric" },
    { field: "quantitySold", key: "quantitySold", title: props.returnLocalizedString("m0289"), minWidnt: 20, headerClassName: "numeric", className: "numeric" },
    { field: "status", key: "status", title: props.returnLocalizedString("m0290"), minWidnt: 20 },
    { key: "button", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: IconButtonCell },
    { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
]};

const ADJUST_PADDING = 0;
const COLUMN_MIN = 4;

class PartLookupPage extends React.Component {
    _export;

    minGridWidth = 0;

    dataGrid;

    //constructor(props) {
    //    super(props);
    //    this.dataGrid = null;
    //}

    state = {
        partsPerformanceData: null,
        searchParams: {
            selectedPartNumber: "",
            checkOtherStores: false
            // selectedVendor
            // selectedPartStatus

        },

        // flag indicating if the most recent search was done using the "check other stores" option ...
        // if so, then we'll want to modify which columns show up in the results
        searchedUsingCheckOtherStores: false,

        sort: [
            {
                field: "partNumber",
                dir: "asc"
            }
        ],
        skip: 0,
        take: 10,

        showDetailsDialog: false,
        selectedPart: null,

        setMinWidth: false,
        gridCurrent: 0
    };

    pageChange = event => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    };

    expandChange = event => {
        // API: https://www.telerik.com/kendo-react-ui/components/grid/api/GridExpandChangeEvent/
        //debugger;

        // event.dataItem.expanded = event.value;
        // this.forceUpdate();
        // return;

        //event.dataItem.expanded = !event.dataItem.expanded;

        // if collapsing the row, OR the row already has subdata, then no need to try and
        // fetch the subdata underneath this row

        // close the row if that's what the user indicates he wants to do
        if (!event.value) {
            event.dataItem.expanded = false;
            this.forceUpdate();
            return;
        }

        // if we already have child data loaded up for this row, then don't do anything
        if (event.dataItem.details !== undefined) {
            event.dataItem.expanded = event.value;
            this.forceUpdate();
            return;
        }

        let orgVendorID = event.dataItem.orgVendorID;
        let partNumber = event.dataItem.partNumber;
        let orgID = event.dataItem.orgID;

        // replace slashes with triple ! so it can be passed into API URL cleanly
        partNumber = partNumber ? escapeSlashes(partNumber) : "";

        this.props
            .getData(
                `/api/portal/part/${partNumber}/GetSummaryDetails?orgVendorID=${orgVendorID}&orgID=${orgID}`
            )
            .then(response => {
                event.dataItem.expanded = event.value;
                // child data for the chosen part
                //const data = response.data;

                // make a shallow copy of the main grid data, so we can manipulate it by appending the requested child data
                let data = this.state.partsPerformanceData.slice();

                // get index of the row we're trying to expand
                let index = data.findIndex(
                    d =>
                        d.orgID === orgID &&
                        d.orgVendorID === orgVendorID &&
                        d.partNumber === partNumber
                );

                // attach the child data a newly-created "details" property of the data for the selected row
                data[index].details = response.data;

                this.forceUpdate();


            })
            .catch(error => {
                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0291")
                );
            });
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleSearch = e => {
        // get the items selected from the search filters control
        e.preventDefault();

        let builder = new queryStringBuilder();

        const searchParams = this.state.searchParams;
        const orgType = this.context.state.orgType;

        // check if all required parts have been entered
        if (isEmpty(searchParams.selectedPartNumber)) {
            this.props.alert(
                "error",
                this.props.returnLocalizedString("m0023"),
                this.props.returnLocalizedString("m0292")
            );
            return;
        }
        if (searchParams.checkOtherStores && (!(searchParams.selectedVendor) || isEmpty(searchParams.selectedVendor.orgVendorID))) {
            this.props.alert(
                "error",
                this.props.returnLocalizedString("m0023"),
                this.props.returnLocalizedString("m0293")
            );
            return;
        }

        // run the api search for the parts using these search parameters

        //let queryString = "";
        if (searchParams.selectedPartNumber) {
            builder.append("partNumber", searchParams.selectedPartNumber.trimEnd());
        }
        let orgID;
        if (searchParams.selectedDealership) {
            orgID = searchParams.selectedDealership.orgID;
            if (orgID > 0)
                builder.append("orgID", orgID);
        }
        if (searchParams.selectedVendor && !isEmpty(searchParams.selectedVendor.orgVendorID)) {
            if (orgType === "dealer") {
                builder.append("orgVendorID", searchParams.selectedVendor.orgVendorID);
            }
            else if (orgType === "dealergroup") {
                if (orgID > 0) {
                    // a particular dealer is selected
                    builder.append("orgVendorID", searchParams.selectedVendor.orgVendorID);
                }
                else {
                    // All Dealerships is selected
                    builder.append("vendorID", searchParams.selectedVendor.orgVendorID);
                }
            }
        }
        if (searchParams.checkOtherStores) {
            builder.append("checkOtherStores", 1);

        }

        // filter the data
        this.props
            .getData(
                `/api/portal/part/GetPerformanceStats${builder.queryString}`
            )
            .then(response => {
                // grid may not exist yet, but it has the same width as the search-controls, so use it to calculate column widths
                //this.grid = document.querySelector('.k-grid');
                this.grid = document.querySelector('.search-controls');
                window.addEventListener('resize', this.handleResize);

                this.minGridWidth = 1171;
                columns(this.props).map(item => this.minGridWidth += item.minWidnt);

                this.setState({
                    partsPerformanceData: response.data,
                    searchedUsingCheckOtherStores: this.state.searchParams.checkOtherStores,

                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: this.grid.offsetWidth < this.minGridWidth
                });
                this.dataGrid.freshLoad = true;
            })
            .catch(error => {

                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0294")
                );
            });

        // this.setState({
        //   		partsPerformanceData: partsPerformanceData
        //   	});
    };

    handleResize = () => {
        //console.log("grid.offsetWidth: ", this.grid.offsetWidth);

        if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
            this.setState({
                setMinWidth: true
            });
        } else if (this.grid.offsetWidth > this.minGridWidth) {
            this.setState({
                gridCurrent: this.grid.offsetWidth,
                setMinWidth: false
            });
        }
    }

    setWidth = (minWidth, percentage) => {
        //console.log("state.gridCurrent: ", this.state.gridCurrent);
        //if (this.grid)
        //    console.log("grid.offsetWidth: ", this.grid.offsetWidth);
        //let columnsLength;
        //if (this.context.state.allowEditSuggestedOrders)
        //    columnsLength = columnsAllowEdit.length;
        //else
        //    columnsLength = columnsNotAllowEdit.length;
        //let width = this.state.setMinWidth ? minWidth :
        //    minWidth + (this.state.gridCurrent - this.minGridWidth) / columnsLength;
        let width = this.state.setMinWidth ? minWidth :
            Math.round(this.state.gridCurrent / 100 * percentage);
        width = width < COLUMN_MIN ? width : width - ADJUST_PADDING;
        //console.log("width: ", width);
        return width;
    }

    handleSearchParamsChange = e => {
        this.setState({
            searchParams: {
                ...this.state.searchParams,
                [e.target.name]: (e.target.name === "checkOtherStores") ? e.target.checked : e.target.value
            }
        });
    };

    export = () => {
        this._export.save(this.state.partsPerformanceData);
    };

    rowRender = (row, props) => {
        let newRow = row;
        // check if the part in question has any superseded history; if not, then hide the expander
        if (!props.dataItem.supersededHistory) {
            newRow.props.children[0] = (<td key={uuidv4()}></td>);
        }
        return newRow
    }

    handleDetailsClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDetailsDialog: true,
            selectedPart: props.dataItem
        })
    }

    handleCloseDetailsModal = (e, props) => {

        this.setState({
            showDetailsDialog: false,
            selectedPart: null
        });
    }

    render() {
        const searchParams = this.state.searchParams;
        const orgType = this.context.state.orgType;

        let showLocationColumn = false;
        let orgID;
        if (searchParams.selectedDealership) {
            orgID = searchParams.selectedDealership.orgID;
        }
        switch (orgType) {
            case "dealer":
                showLocationColumn = this.state.searchedUsingCheckOtherStores;
                break;
            case "dealergroup":
                showLocationColumn = orgID === 0 || this.state.searchedUsingCheckOtherStores;
                break;
            case "manufacturer.region":
                showLocationColumn = orgID === 0;
                break;
            case "manufacturer":
                showLocationColumn = orgID === 0;
                break;
            default:
                break;
        };

        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;

        // 646px is the perfect width with the current css styles
        let perfectPartDemandDialogWidth = 646;
        let partDemandDialogWidth = `${perfectPartDemandDialogWidth}px`;
        if (this.state.showDetailsDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectPartDemandDialogWidth)
                    partDemandDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        const tabs = (<Tabs>
            <Tab label= {this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label= {this.props.returnLocalizedString("m0295")} ></Tab>
        </Tabs>);

        //const columns = [];

        //!DBTRANS! @m0004@ Home !DEVNOTE! Option label
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0257@ Part number !DEVNOTE! Input field label
        //!DBTRANS! @m0258@ Description !DEVNOTE! Input field label
        //!DBTRANS! @m0259@ Vendor !DEVNOTE! Input field label
        //!DBTRANS! @m0281@ Demand !DEVNOTE! Option label
        //!DBTRANS! @m0282@ Effective Date !DEVNOTE! Text label
        //!DBTRANS! @m0283@ Old Part # !DEVNOTE! Text label
        //!DBTRANS! @m0284@ New Part # !DEVNOTE! Text label
        //!DBTRANS! @m0285@ No details to show. !DEVNOTE!  Text label
        //!DBTRANS! @m0286@ Location !DEVNOTE! Column Label
        //!DBTRANS! @m0287@ Qty Available !DEVNOTE! Column Label
        //!DBTRANS! @m0288@ Qty Sales In Progress !DEVNOTE! Column Label
        //!DBTRANS! @m0289@ Qty Sold !DEVNOTE! Column Label
        //!DBTRANS! @m0290@ Status !DEVNOTE! Column Label
        //!DBTRANS! @m0291@ Unable to fetch details for this part number. !DEVNOTE! Action status
        //!DBTRANS! @m0292@ You must specify a part number. !DEVNOTE! Action status reason
        //!DBTRANS! @m0293@ You must specify a vendor if you also want to check other stores. !DEVNOTE! Action status reason
        //!DBTRANS! @m0294@ Unable to retrieve part data. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0295@ Part Lookup !DEVNOTE! Page title
        //!DBTRANS! @m0296@ Location !DEVNOTE! Column

        return (
            <div>
                <Header title={this.props.returnLocalizedString("m0295")} tabs={tabs} />

                <section className="page-content grid-row pad-it">
                    <PartLookupSearchBox
                        searchParams={this.state.searchParams}
                        handleSearchParamsChange={this.handleSearchParamsChange}
                        handleSearch={this.handleSearch}
                    />
                    {this.state.partsPerformanceData ? (

                        <GridContainer
                            sortColumn="partNumber"
                            data={this.state.partsPerformanceData}
                            pageable={true}
                            detail={localize(DetailComponent)}
                            onExpandChange={this.expandChange}
                            rowRender={this.rowRender}
                            excelFilename={getExportFileName("Parts-Performance")}
                            ref={(g) => { this.dataGrid = g; }}
                            pageSizes={[5, 10, 20]}
                            pageSize={10}
                        >
                            {
                                // if the most recent search was performed using the "check other stores" option, then we want to show this column
                                (showLocationColumn) ? (
                                    <Column
                                        field="location"
                                        title={this.props.returnLocalizedString("m0286")}
                                        width={this.setWidth(120, 10)}
                                    />
                                ) : <React.Fragment />}
                            <Column
                                field="partNumber"
                                title={this.props.returnLocalizedString("m0257")}
                                width={this.setWidth(120, 10)}
                            />
                            <Column
                                field="description"
                                title={this.props.returnLocalizedString("m0258")}
                                width={this.setWidth(285, 24)}
                            />

                            <Column
                                field="vendorCode"
                                title={this.props.returnLocalizedString("m0259")}
                                width={this.setWidth(130, 11)}
                            />
                            <Column
                                field="quantityAvailable"
                                title={this.props.returnLocalizedString("m0287")}
                                width={this.setWidth(120, 10)}
                                headerClassName="numeric"
                                className="numeric"
                            />
                            <Column
                                field="qtySalesInProgress"
                                title={this.props.returnLocalizedString("m0288")}
                                width={this.setWidth(120, 10)}
                                headerClassName="numeric"
                                className="numeric"
                            />
                            <Column
                                field="quantitySold"
                                title={this.props.returnLocalizedString("m0289")}
                                width={this.setWidth(120, 10)}
                                headerClassName="numeric"
                                className="numeric"
                            />

                            <Column
                                field="status"
                                title={this.props.returnLocalizedString("m0290")}
                                width={this.setWidth(120, 10)}

                            />
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                editable={false}
                                width={this.setWidth(36, 3)}
                                cell={(props) => (
                                    <IconButtonCell handleClick={(e) => { this.handleDetailsClick(e, props) }} icon="Details" title={this.props.returnLocalizedString("m0281")} {...props} />
                                )}
                            />
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                cell={(props) => (
                                    <BlankCell {...props} />
                                )}
                            />
                        </GridContainer>

                    ) : (
                            <span />
                        )}
                </section>
                {this.state.showDetailsDialog && (
                    <Dialog
                        className="demand"
                        style={{ top: top }}
                        width={partDemandDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <PartDemandPage
                            handleCloseModal={this.handleCloseDetailsModal}
                            orgID={this.state.selectedPart.orgID}
                            orgVendorID={this.state.selectedPart.orgVendorID}
                            partNumber={this.state.selectedPart.partNumber} />
                    </Dialog>)
                }
            </div>
        );
    }
}

export default isPage(PartLookupPage);
PartLookupPage.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/PartLookupPage.js